export default "__VITE_ASSET__DkOqwcgE__ 100w";